import { Modal } from 'antd-mobile';
import React from 'react'
import BoxColor from '../../../BoxType';

export function showDownloadGameAlert(downloadTitle) {
  return new Promise((resolve, reject) => {
    Modal.show({
      bodyStyle:{
        padding:'20px 20px 10px',
        borderRadius:'18px'
      },
      maskClassName:'select-account-mask',
      bodyClassName:'select-account-body',
      getContainer:document.getElementById('root'),
      title:<div style={{fontSize:'17px',fontWeight:'500',color:'#282828',marginBottom:'10px'}}>温馨提示</div>,
      content:<div style={{fontSize:'13px',color:'#666',textAlign:'center'}}>您在当前游戏暂无小号，请先下载游戏创建小号后领取</div>,
      closeOnAction: true,
      actions: [
        {
          key: "done",
          text: downloadTitle ? downloadTitle : "立即下载",
          primary: true,
          className: 'done',
          style: {
            backgroundColor: `${BoxColor()}`,
            border: 'none',
            width: '90%',
            margin: '0 auto',
            borderRadius: '24px',
            fontWeight: 500,
            fontSize: '15px',
          },
          onClick: ()=>{
            Modal.clear()
            setTimeout(() => {
              resolve()
            }, 400);
          } 
        },
        {
          key: "cancel",
          text: "取消",
          className: 'cancel',
          style:{
            color:'#999',
            fontSize:'13px',
            padding:'10px'
          },
          onClick: reject
        },
      ],
    });
  })
}

export function showManualCreateAlert() {
  return new Promise((resolve, reject) => {
    Modal.show({
      bodyStyle:{
        padding:'20px 20px 10px',
        borderRadius:'18px'
      },
      maskClassName:'select-account-mask',
      bodyClassName:'select-account-body',
      getContainer:document.getElementById('root'),
      title:<div style={{fontSize:'17px',fontWeight:'500',color:'#282828',marginBottom:'10px'}}>创建小号</div>,
      content:<div>
        <div style={{fontSize:'11px',color:'#666',paddingBottom:'15px'}}>请输入小号名称（最多八个字）</div>
        <input type="text" style={{
          border:'none',
          backgroundColor:'#F7F7F7',
          borderRadius:'4px',
          padding:'10px 15px',
          color:'#282828',
          fontSize:'14px',
          width:'100%'
          }}/>
      </div>,
      closeOnAction: true,
      actions: [
        {
          key: "done",
          text: "确认",
          primary: true,
          className: 'done',
          style: {
            backgroundColor: `${BoxColor()}`,
            border: 'none',
            width: '90%',
            margin: '0 auto',
            borderRadius: '24px',
            fontWeight: 500,
            fontSize: '15px',
          },
          onClick: resolve
        },
        {
          key: "cancel",
          text: "取消",
          className: 'cancel',
          style:{
            color:'#999',
            fontSize:'13px',
            padding:'10px'
          },
          onClick: reject
        },
      ],
    });
  })
}